function isFormDataObject(value) {
    if (Array.isArray(value) || null == value || 'object' != typeof value || value instanceof Blob) return false;
    return true;
}
function buildRequestFormData(bodyParameters) {
    const keys = Object.keys(bodyParameters);
    if (0 === keys.length) return;
    const singleValue = bodyParameters[keys[0]];
    return 1 === keys.length && isFormDataObject(singleValue) ? singleValue : bodyParameters;
}
function convertToFormData(payload) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(payload))if (Array.isArray(value)) for (const element of value)addDataToFormData(formData, key, element);
    else addDataToFormData(formData, key, value);
    return formData;
}
function addDataToFormData(formData, key, value) {
    if (null == value) return;
    if (value instanceof Blob) formData.append(key, value);
    else if ('object' == typeof value) formData.append(key, JSON.stringify(value));
    else formData.append(key, value);
}
export { buildRequestFormData, convertToFormData };
